import { useMutation, useQueryClient } from "react-query";

import { crearRegistroPlan,crearRegistroPlanCliente, updateRegistroPlan, deleteRegistroPlan} from '../../services/RegistroPlanes';

import { toast } from 'react-hot-toast';
const queryKey = "registro";

export const useRegistroMutations = () => {
  const queryClient = useQueryClient();
  const onError = (err = null) => {
    if (err.statusCode === 409) {
      return toast.error(`El valor ${err.duplicateValue} ya se encuentra registrado`);
    }
    toast.error('Error consulte con Soporte!');
  };

  const onSuccess = () => {
    toast.success('Datos Guardados Exitosamente!');
    queryClient.invalidateQueries(queryKey);
  };
  const addRegistro = useMutation((body) => crearRegistroPlan(body), {
    onSuccess,
    onError: (err) => onError(err),
  });

  const addRegistroCliente = useMutation((body) => crearRegistroPlanCliente(body), {
    onSuccess,
    onError: (err) => onError(err),
  });

  const updateRegistroD = useMutation(
    (body) => updateRegistroPlan( body),
    {
      onSuccess,
      onError: (err) => onError(err),
    }
  );
  const removeRegistro = useMutation((id) => deleteRegistroPlan( id), {
    onSuccess,
    onError,
  });

  return { addRegistro, addRegistroCliente, updateRegistroD, removeRegistro };
};
export default useRegistroMutations;